<template>
    <Modal v-model="visible" title="签署二维码" width="800" :mask-closable="false" footer-hide>
        <div class="qrcode-container">
            <div v-if="loading" class="loading-wrapper">
                <Spin size="large">
                    <div class="loading-text">加载中...</div>
                </Spin>
            </div>

            <div v-else-if="signerList.length > 0" class="qrcode-grid">
                <div v-for="(signer, index) in signerList" :key="index" class="qrcode-item">
                    <div class="qrcode-image">
                        <img v-if="signer.link_url" @click="goSee(signer)" :src="signer.link_url" alt="签署二维码" @error="handleImageError" />
                        <div v-else class="no-qrcode">暂无二维码</div>
                    </div>
                    <div class="signer-info">
                        <div class="signer-name">{{ signer.name || '签署者名称' }}</div> 
                        <div class="signer-phone">{{ signer.phone || '-' }}</div>
                        <div class="signer-code">验证码：{{ signer.verification_code || '-' }}</div>
                    </div>
                </div>
            </div> 
            <div v-else class="empty-wrapper">
                <p>暂无签署数据</p>
            </div>
 
        </div>
    </Modal>
</template>

<script>
import { get_signing_link } from '@/api/tang'

export default {
    name: 'QRCodeModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        contractId: {
            type: [String, Number],
            default: ''
        }
    },
    data() {
        return {
            visible: this.value,
            loading: false,
            refreshing: false,
            signerList: []
        }
    },
    watch: {
        value(newVal) {
            this.visible = newVal
            if (newVal && this.contractId) {
                this.fetchSigningLink()
            }
        },
        visible(newVal) {
            this.$emit('input', newVal)
            if (!newVal) {
                this.$emit('on-close')
            }
        },
        contractId(newVal) {
            if (newVal && this.visible) {
                this.fetchSigningLink()
            }
        }
    },
    methods: {
        goSee(url) {
            //图片是base64的，需要转换为图片
            let img = new Image()
            img.src =  url.link_url
            img.onload = () => {
                this.$Modal.info({
                    title: url.name + '的签署二维码',
                    content: '<img style="width:250px;height:250px" src="' + img.src + '" />'
                })
            } 
        },
        // 获取签署链接和二维码数据
        async fetchSigningLink() {
            if (!this.contractId) {
                this.$Message.warning('缺少合同ID')
                return
            }

            this.loading = true
            try {
                const res = await get_signing_link({
                    contract_id: this.contractId
                })

                if (res.code === 200 && res.data) {
                    // 根据实际返回数据结构处理
                    // 假设返回的是签署者列表
                    if (Array.isArray(res.data)) {
                        this.signerList = res.data
                    } else if (res.data.list && Array.isArray(res.data.list)) {
                        this.signerList = res.data.list
                    } else {
                        // 如果是单个对象，转换为数组
                        this.signerList = [res.data]
                    }
                } else {
                    this.$Message.error(res.msg || '获取签署链接失败')
                    this.signerList = []
                }
            } catch (error) {
                console.error('获取签署链接失败:', error)
                this.$Message.error('获取签署链接失败')
                this.signerList = []
            } finally {
                this.loading = false
            }
        },

        // 刷新二维码
        async handleRefresh() {
            this.refreshing = true
            await this.fetchSigningLink()
            this.refreshing = false
            this.$Message.success('刷新成功')
        },

        // 关闭弹窗
        handleClose() {
            this.visible = false
        },

        // 图片加载失败处理
        handleImageError(e) {
            console.error('二维码图片加载失败', e)
        }
    }
}
</script>

<style scoped lang="scss">
.qrcode-container {
    min-height: 400px;
    position: relative;

    .loading-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;

        .loading-text {
            margin-top: 10px;
            color: #999;
        }
    } 
    .qrcode-grid {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 20px;
        padding: 20px 0;
        max-height: 400px;
        overflow-y: auto;

        .qrcode-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px;
            background: #f5f7fa;
            border-radius: 8px;
            transition: all 0.3s;

            &:hover {
                background: #e8eaec;
                transform: translateY(-2px);
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }

            .qrcode-image {
                width: 120px;
                height: 120px;
                background: white;
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 10px;
                padding: 5px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }

                .no-qrcode {
                    color: #c5c8ce;
                    font-size: 12px;
                    text-align: center;
                }
            }

            .signer-info {
                text-align: center;
                width: 100%;

                .signer-name {
                    font-size: 14px;
                    color: #333;
                    font-weight: 500; 
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .signer-code {
                    font-size: 12px;
                    color: #666;
                }
            }
        }
    }

    .empty-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 400px;
        color: #999;
        font-size: 14px;
    }

    .modal-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 20px;
        border-top: 1px solid #e8eaec;
        margin-top: 20px;
    }
}

// 自定义滚动条样式
.qrcode-grid::-webkit-scrollbar {
    width: 6px;
}

.qrcode-grid::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.qrcode-grid::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
        background: #a8a8a8;
    }
}
</style>
